"use client";

import React from "react";
import { Quote } from "lucide-react";

interface PullQuoteProps {
  children: React.ReactNode;
  author?: string;
}

export const PullQuote = ({ children, author }: PullQuoteProps) => {
  return (
    <div className="my-20 flex flex-col items-center text-center px-6">
      <div className="w-12 h-12 rounded-2xl bg-brand-1/10 flex items-center justify-center text-brand-1 mb-8">
        <Quote className="w-6 h-6 fill-current" />
      </div>
      <blockquote className="text-2xl md:text-3xl lg:text-4xl font-black text-white leading-tight tracking-tight mb-6 max-w-2xl italic">
        "{children}"
      </blockquote>
      {author && (
        <cite className="text-xs font-black uppercase tracking-[0.3em] text-brand-1 not-italic">
          — {author}
        </cite>
      )}
    </div>
  );
};

export default PullQuote;
